import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
import MyImage from "../../images/white_background.JPG";
import CaroselSection from "../../components/caroselSection";
class About extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // const options = {
    //   items: 4,
    //   nav: true,
    //   navText: [
    //     "<div className='nav-btn prev-slide'></div>",
    //     "<div className='nav-btn next-slide'></div>",
    //   ],
    //   rewind: true,
    //   autoplay: true,
    //   slideBy: 1,
    //   dots: true,
    //   dotsEach: true,
    //   dotData: true,
    // };
    return (
      <div>
        <Navigations />
        <div class="container-fluid">
          <div style={{ marginTop: "5rem" }}>
            <div
              style={{
                borderBottom: "3px solid black",
                textAlign: "center",
              }}
            >
              <h1 style={{ color: "rgb(118, 102, 223)" }}>About Adnan Ahmed</h1>
            </div>
            <section class="py-5">
              <div class="container">
                <div class="row">
                  <div class="col-md-4">
                    <img
                      // class="imageSt"
                      // style={{ borderRadius: "50%" }}
                      src={MyImage}
                      alt="Adnan Ahmed"
                    />
                  </div>
                  <div class="col-md-8">
                    <h2 className="text-center">
                      Creative | Passionate | Focused
                      {/* Creation without Limits */}
                    </h2>
                    {/* <p class="mb-5" >
                      Currently I'm a freelance designer and web developer, who
                      works with a variety of clients and on many diverse
                      projects. I work to create innovative solutions that
                      inspire, and foster memorable relationships between brands
                      and their clients. With a focus on branding and UI / Web,
                      I strive to create usable and polished products through
                      passionate and deliberate design.
                    </p> */}
                    <p style={{ fontSize: "18px" }}>
                      I'm Adnan Ahmed, I'm a Freelance Web & Mobile App
                      Developer based in Karachi, PAKISTAN..
                    </p>
                    <p style={{ fontSize: "18px" }}>
                      I have been crafting modern, usable interfaces for the web
                      and mobile apps with clients around the world.
                    </p>
                    <p style={{ fontSize: "18px" }}>
                      Currently working on modern platforms and technologies
                      like React Native Material Design (Materialize CSS,
                      Material UI React), JavaScript, ReactJs, Redux, Firebase,
                      Bootstrap, HTML, HTML5, CSS, CSS3, Github, & Third-Party
                      API Integrations, etc.
                    </p>
                    <p style={{ fontSize: "18px" }}>
                      Have strong knowledge in developing single-page
                      applications (SPA) with pixel perfect UI/UX design.
                    </p>
                    <p style={{ fontSize: "18px" }}>
                      Please contact me, I'll be glad to talk with you about
                      your project!
                    </p>
                  </div>
                </div>
                <div class="py-5">
                  <h2
                    className="text-center mb-5"
                    style={{ color: "rgb(118, 102, 223)" }}
                  >
                    Technologies I Have Worked With
                  </h2>
                  <CaroselSection />
                </div>
              </div>
            </section>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

About.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(About);
